enum pageRoutes {
  // INITIAL
  START_PAGE = "/panel/cockpits", // unused
  // PANEL
  PANEL = "/panel",
  Documents = "/panel/documents",
  Cockpits = "/panel/cockpits",
  Cabins = "/panel/cabins",
  Assignment = "/panel/assignment",
  Create_Cockpit = "/panel/cockpit/create",
  Create_Cabin = "/panel/cabin/create",
  Continue_Create_Cockpit = "/panel/cockpit/create/continue",
  Continue_Create_Cabin = "/panel/cabin/create/continue",

  // ERROR
  ER404 = "/error/404", // NotFound
  ER403 = "/error/403",
  ER500 = "/error/500",

  // HEALTH
  HEALTH_GET = "/health",
}

export { pageRoutes };
